import { Component, EventEmitter, OnInit, Output, AfterViewInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { MatCheckbox, MatRadioButton } from '@angular/material';
import { ThousandSeparatorPipe } from '../../pipes/thousand-separator.pipe';
import { SharedService } from '../../services/sharedService';
import { ProcessService } from '../../services/process.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { Column } from '../form-creation/form-creator/column';
@Component({
  selector: 'tas-table',
  templateUrl: './tas-table.component.html',
  styleUrls: ['./tas-table.component.css'],

})
export class TasTableComponent implements OnInit {
  @ViewChildren('blockName') blocks: QueryList<ElementRef>
  //form editing section
  rowTypes = ["string", "number", "date", "checkbox"]
  styles = ["input","group", "text"]



  @Input() processId;
  @Input() processKey;
  @Input() stageKey;
  @Input() stageData;
  @Input() globals = {}
  @Output() onSelectedValue = new EventEmitter<any>();
  @Output() onRowKeyValue = new EventEmitter<any>();
  @Input() stage: any;
  @Input() selectedBlk: any;
  @Input()
  formCreation: boolean;
  @Input()
  username;
  dataSourceOld = [];
  dataSources = [];
  originalData = [];
  categoryTableData: any;
  categoryTableColumns = [];
  originalDisplayedColumns = null;
  inputValues = {};
  attachments = {};
  backingData = [];
  requiredFields = [];
  stageOutput: any;
  globalsOutput: any;
  multiColumn: boolean;
  editMode = false;
  thisYear = new Date().getFullYear();
  mCategories = []
  multiColumns = []
  categoryHeader = ""
  hasColumns = "0"
  data = {
    'thisYear': this.thisYear,
    'previousYear': this.thisYear - 1,
    'previousYearProcesses': {
      'dsf': {}
    },
    'processes': {
      'dsf': this.inputValues
    }
  };
  columnNames = {
    'name': 'Name',
    'key': 'Value'
  };

  columnStyles = {
  };

  columnNames2 = {
    'name': 'Name',
    'key': 'Value'
  };
  header_created = false;

  backingDataCounter = 0;

  clr = 1
  constructor(private thousandSeparatorPipe: ThousandSeparatorPipe, private sharedSevice: SharedService,
    public processService: ProcessService,  private spinner: NgxSpinnerService) {

  }
  keytab(event) {
    if (event.key === "Enter") {
      // let element = event; // get the sibling element
      // console.log(element)
      // if (element == null) {

      //   return;
      // } // check if its null

      // else {
      //   console.log('focus')
      //   element.next(':input').focus()
      // }
    }
  }

  getColor() {
    if (this.clr === 1) {
      this.clr = 0
      return "#e6e6e6"
    }
    this.clr = 1
    return "lightgrey"
  }
  processStageStructure() {
    for (const block of this.stage.blocks) {
      var dataSource1 = [];
      this.originalData = [];
      var displayedColumns = ['name'];
      var upperHeaderColumns = [];
      if (block.columns === undefined || block.columns.length===0) {
        for (const row of block.rows) {
          this.originalData.push({ name: row.name, key: row.key, default: row.default, enabled: row.default, mapping: row.mapping, style: row.style, type: row.type, required: row.required, global: row.global,hasAttachment: row.hasAttachment, fusionTransfer: row.fusionTransfer });
          if (this.stageData !== undefined) {
            var v = this.stageData.rows.find(cols => cols[row.key] !== undefined);
            if (v !== undefined) {
              this.inputValues[row.key] = v[row.key];
              this.stageOutput.rows.push({ [row.key]: v[row.key] });
              if (row.required !== undefined && row.required === true)
                this.requiredFields.splice(this.requiredFields.indexOf(row), 1)
            }
          }
          if (row.required !== undefined && row.required === true) {
            if (this.inputValues[row.key] === undefined || this.isEmptyOrSpaces(this.inputValues[row.key])) {
              this.requiredFields.push(row.key);
            }
          }
        }
        this.multiColumns[block.key] = false;
      } else {
        for (const row of block.rows) {
          const sourceRow = { name: row.name, key: row.key, default: row.default, enabled: row.default, mapping: row.mapping, style: row.style, bold: row.bold };
          this.inputValues[row.key] = {};
          if (this.stageData !== undefined) {
            var v = this.stageData.rows.find(cols => cols['key'] === row.key);
            if (v !== undefined) {
              for (const value of v.values) {
                var objKey = Object.keys(value)[0];
                this.inputValues[row.key][objKey] = value[objKey];
                var vxs = this.stageOutput.rows.find(cols => cols['key'] === row.key);
                if (vxs !== undefined) {
                  vxs.values.push({ [objKey]: value[objKey] });
                } else {
                  this.stageOutput.rows.push({ 'key': row.key, 'values': [{ [objKey]: value[objKey] }] });
                }
              }
            }
          }
          //if (row.values!==undefined)
          for (const value of row.values) {
            if (sourceRow['required'] === undefined) {
              sourceRow['required'] = [];
            }
            sourceRow['required'][value.column] = value.required
            if (value.required !== undefined && value.required === true) {
              if (this.inputValues[row.key][value.column] === undefined || this.isEmptyOrSpaces(this.inputValues[row.key][value.column])) {
                this.requiredFields.push(row.key + "." + value.column);
              }
            }


            if (sourceRow['types'] === undefined) {
              sourceRow['types'] = [];
            }
            sourceRow['types'][value.column] = value.type

            if (sourceRow['fontWeight'] === undefined) {
              sourceRow['fontWeight'] = [];
            }
            sourceRow['fontWeight'][value.column] = value.bold ? 'bold' : value.fontWeight

            if (value.formula === undefined){
              sourceRow[value.column] = value.value;
            }
              
            else {
              sourceRow[value.column] = value.formula
              sourceRow['style'] = 'bold'
            }
            sourceRow
          }
      
          this.originalData.push(sourceRow);
        }
        for (const column of block.columns) {
          displayedColumns.push(column.key);
          this.columnNames[column.key] = column.name;
          this.columnStyles[column.key] = column.bold ? '800' : 'normal'
        }
        if (block.columnGroups !== undefined) {
          var grpCounter = 0;
          for (const column of block.columnGroups) {
            upperHeaderColumns[grpCounter] = column.name
            grpCounter++;
          }
        }
        this.multiColumns[block.key] = true;
      }
      dataSource1 = this.originalData.filter(elem => {
        return elem.enabled === true;
      });
      if (block.colType === "2" && this.stageData) {
        for (let x = 0; x < this.stageData.rows.length; x++) {
          let r = this.stageData.rows[x];
          if (r.key) {
            let spl = r.key.split("#####");
            if (spl.length > 1 && block.key === spl[0]) {
              this.stageOutput.rows.push({key: r.key, values: r.values})
              let result = r.values.reduce((obj, item) => {
                for (let key in item) {
                  obj[key] = item[key];
                }
                return obj;
              }, {});
              this.inputValues[r.key] = result;
              let cloneDatasource = Object.assign([], dataSource1);
              let m = cloneDatasource[cloneDatasource.length - 1];
              let newRow = Object.assign({}, m);
              newRow.key = r.key;
              cloneDatasource.push(newRow);
              dataSource1 = cloneDatasource;
            }
          }
        }
        
      }
    
      this.dataSources.push({ 'datasource': dataSource1, fusionTable:block.fusionTable, rows:block.rows, columns:block.columns, 'displayedColumns': displayedColumns, 'multiColumn': this.multiColumns[block.key], 'blockName': block.name, 'columnGroups': block.columnGroups, 'upperHeaderColumns': upperHeaderColumns, colType: block.colType });
    }
    this.stageOutput['name'] = this.stage.name
    this.stageOutput['globals'] = this.globals ? this.globals : {}
    this.onSelectedValue.emit(this.stageOutput);
    setTimeout(()=>{ // this will make the execution after the above boolean has changed
      if (this.blocks.toArray()[this.selectedBlk]) this.blocks.toArray()[this.selectedBlk].nativeElement.focus();
    },0);  
  }

  processPreviousYearJSON(data) {
    for (const stage of data.stages) {
      for (const row of stage.rows) {
        if (row.key === undefined) continue
        for (const value of row.values) {
          this.data.previousYearProcesses.dsf[row.key] = {}
          this.data.previousYearProcesses.dsf[row.key][Object.keys(value)[0]] = value[Object.keys(value)[0]];
        }
      }
    }
  }

  ngOnInit() {

    if (this.processId) {
      this.processService.getAttachments(this.processId, this.stageKey).subscribe
        (attachments => {
       
          this.attachments = {};
          attachments.forEach(att => {
            for (var key in att[this.stageKey]) {
              this.attachments[key] = att[this.stageKey][key]
            }
          })
          this.initialize()
        });
    } else {
      this.initialize()
    }

   
 
  }

  initialize() {
    this.stageOutput = {
      'key': this.stageKey,
      'rows': []
    };
      this.processStageStructure();
      //this.onSelectedValue.emit(this.stageOutput);
  }

  renderMustache(template, index) {
    if (!template) return
    if (template.indexOf('{{') === -1) return index === 0 ? "" : template
    const string = template.replace(
      /{{\s?([^{}\s]*)\s?}}/g,
      (substring, parsedKey) => {
        const replacer = parsedKey.split('.').reduce((o, i) => {
          if (o !== undefined) {
            return o[i]
          }
        },
          this.inputValues)
        return typeof replacer !== 'undefined' ? replacer : 0;
      }
    );
    if (string === template || string.indexOf('{{') !== -1) {
      return null;
    } else {
      try {

        var res = eval(string);
        if (isNaN(res)) {
          return res;
        }
        else {
          return new Intl.NumberFormat('en-IN').format(res);
        }

      } catch (e) {
        return 'Incorrect value in input field.';
      }
    }
  }
  a = 0;
  getToggleColor() {
    if (this.a === 0) {
      this.a = 1;
      return "#6699ff"

    }
    this.a = 0;
    return "white"
  }
  arrangeRequiredField(required, rowKey) {
    if (this.requiredFields.find(elem => elem === rowKey) !== undefined) {
      this.requiredFields.splice(this.requiredFields.indexOf(rowKey), 1)
    }
    else if (required && this.isEmptyOrSpaces(this.getEventValue(event))) {
      this.requiredFields.push(rowKey)
    }
  }

  onChange(rowElem, col = null, multiColumn, event) {
    let row = rowElem['key']
    let required = col !== null ? (rowElem['required'][col] !== undefined ? rowElem['required'][col] : false) : (rowElem['required'] !== undefined ? rowElem['required'] : false)
    let pushed = false;
    let pushedGlobal = false;
    if (!multiColumn) {

      this.arrangeRequiredField(required, row)
      for (const stageRow of this.stageOutput.rows) {
        if (stageRow[row] !== undefined) {
          stageRow[row] = this.getEventValue(event);
          pushed = true;
          break;
        }
      }
      if (!pushed) {
        this.stageOutput.rows.push({
          [row]: this.getEventValue(event)
        });
      }

      if (rowElem['global']) {
        // if (this.stageOutput.globals === undefined) {
        //   this.stageOutput['globals'] = []
        // }
        for (const stageRow of this.stageOutput.globals) {
          if (stageRow[row] !== undefined) {
            stageRow[row] = this.getEventValue(event);
            pushedGlobal = true;
            break;
          }
        }
        if (!pushedGlobal) {
          // this.stageOutput.globals.push({
          //   [row]: this.getEventValue(event)
          // });

          this.stageOutput.globals[row] = this.getEventValue(event)

        }
      }
    } else {

      this.arrangeRequiredField(required, row + '.' + col)
      for (const stageRow of this.stageOutput.rows) {
        if (stageRow['key'] === row) {
          for (const stageValue of stageRow.values) {
            if (stageValue[col] !== undefined) {
              stageValue[col] = this.getEventValue(event);
              pushed = true;
            }
          }
          if (!pushed) {
            if (event.source instanceof MatRadioButton) {
              stageRow.values = []
              stageRow.values.push({
                [col]: this.getEventValue(event)
              });
            } else {
              stageRow.values.push({
                [col]: this.getEventValue(event)
              });
            }
            pushed = true;
          }
        }

      }
      if (!pushed) {
        if (event.source instanceof MatRadioButton) {
          this.stageOutput.rows.push({
            'key': row,
            'values': [{
              [col]: this.getEventValue(event)
            }]
          });
        } else {
          this.stageOutput.rows.push({
            'key': row,
            'values': [{
              [col]: this.getEventValue(event)
            }]
          });
        }
      }
    }
    this.stageOutput['status'] = this.requiredFields.length === 0 ? "done" : "processing"
    this.stageOutput['name'] = this.stage.name
    this.onSelectedValue.emit(this.stageOutput);


  }

  // edit() {
  //   if (!this.editMode) {
  //     this.editMode = true;
  //     this.dataSourceOld = this.originalData;
  //     this.originalDisplayedColumns = this.displayedColumns;
  //     this.displayedColumns = ['default', 'name'];
  //   } else {
  //     this.editMode = false;
  //     this.dataSourceOld = this.originalData.filter(elem => {
  //       return elem.enabled === true;
  //     });
  //     this.displayedColumns = this.originalDisplayedColumns;
  //     this.originalDisplayedColumns = null;
  //   }
  // }

  onColumnTypeChange(ev, selectedBlk){
    this.sharedSevice.updateColType(selectedBlk, ev.value)
  }

  setFusionTransfer(ev, selectedBlk){
    this.sharedSevice.updateFusionTable(selectedBlk, ev)
  }

  downloadFileFromDocFlow(fileObj) {
    this.spinner.show();
    this.processService.downloadFileFromDocflow(fileObj.file).subscribe
      (data => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = fileObj.filename;
        saveAs(file, filename);
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    const stage: SimpleChange = changes.stage;
  }
  isEmptyOrSpaces(str) {
    const stringValue = str.toString();
    return stringValue === null || stringValue.match(/^ *$/) !== null;
  }

  checkboxClick(event, key) {
    const rowToBeChanged = this.originalData.find(elem => {
      return elem.key === key;
    });
    rowToBeChanged.enabled = event.checked;
    if (event.checked === false) {
      if (!this.multiColumn) {
        for (const row of this.stageOutput.rows) {
          if (row[key] !== undefined) {
            delete row[key];
          }
        }
      } else {
        for (let i = 0; i < this.stageOutput.rows.length; i++) {
          if (this.stageOutput.rows[i].key === key) {
            delete this.stageOutput.rows[i];
          }
        }
      }
      Object.keys(this.inputValues[key]).forEach(col => {
        this.inputValues[key][col] = 0;
      });
    }
  }

  onAmountChange(amount: string, name) {
  }

  getEventValue(event) {
    return event.source instanceof MatCheckbox ? event.checked :
      event.source instanceof MatRadioButton ? event.value :
        event.target !== undefined ? event.target.value : event
  }
  printKey(key, col) {
    this.onRowKeyValue.emit("{{" + key + "." + col + "}}");
    this.sharedSevice.emitFormulaKey("{{" + key + "." + col + "}}")
  }


  deleteBlock(blockIndex) {
    this.sharedSevice.updateDeleteBlock(blockIndex)
  }
  renameBlock(name, blockIndex) {
    this.sharedSevice.updateRenameBlock(name, blockIndex)
  }

  addRow(row, dtIndx) {
    this.sharedSevice.updateAddRow(dtIndx, row.row, row.staticTexts)
  }

  updateRow(row, dtIndx) {
    this.sharedSevice.updateUpdateRow(dtIndx, row.row, this.editingRowIndex)
  //  this.cancelRow()
  }

  deleteRow(row, dtIndx) {
    this.sharedSevice.deleteRow(dtIndx, row)
    this.cancelRow()
  }

  cancelRow() {
    this.showEditBtn = true;
    this.editingRowKey = undefined
    this.editingRowIndex = undefined
  }

  editingRowKey: any
  editingRowIndex: any
  showEditBtn = true;

  moveRow(rowKey, dtIndx, direction) {
    this.sharedSevice.updateMoveRow(dtIndx, rowKey, direction)
  }


  editingRow(rowKey, dtIndx, index) {
    this.editingRowKey = rowKey;
    this.editingRowIndex = index;
    //var row = this.stage.blocks[dtIndx].find(elem => elem['key'] === rowKey)
    //this.sharedSevice.updateEditRow(dtIndx, rowKey)
    this.showEditBtn = false;
  }
  editingColumnKey: any
  editingColumnIndex: any
  editingColumn(columnKey, dtIndx, index) {
    this.editingColumnIndex = index
    this.editingColumnKey = columnKey;
    this.showEditBtn = false;
  }

  cancelColumn() {
    this.showEditBtn = true;
    this.editingColumnKey = undefined
    this.editingColumnIndex = undefined
  }

  addColumn(col, dtIndx) {
    this.sharedSevice.updateAddColumn(dtIndx, col)
  }

  deleteColumn(col, dtIndx) {
    this.sharedSevice.deleteColumn(dtIndx, col)
  }

  updateColumn(col, dtIndx) {
    this.sharedSevice.updateColumn(dtIndx, col.column, this.editingColumnIndex)
  }

  getColumn(columns, col){
    var colF = columns.find(elem=>elem.key===col);
    return colF!==undefined?colF:new Column()
  }
}
